import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import { useState } from 'react';

var useInputFocus = function useInputFocus(_ref) {
  var onFocus = _ref.onFocus,
    onBlur = _ref.onBlur;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setFocused = _useState2[1];
  var handleFocus = function handleFocus(e) {
    onFocus === null || onFocus === void 0 || onFocus(e);
    setFocused(true);
  };
  var handleBlur = function handleBlur(e) {
    onBlur === null || onBlur === void 0 || onBlur(e);
    setFocused(false);
  };
  return {
    isFocused: isFocused,
    handleFocus: handleFocus,
    handleBlur: handleBlur
  };
};

export { useInputFocus };
